import { useState } from 'react';
import {
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  Box,
  Collapse,
  IconButton,
  Paper,
} from '@mui/material';

import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';

import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';
import AssesmentDataDetailsRow from './AssesmentDataDetailsRow';

export default function AssesmentDataTableRow(props) {
  const [open, setOpen] = useState(false);
  const { data } = props;

  return (
    <>
      <StyledTableRow dropdown key={data.cropName + ' crop'}>
        <StyledTableCell component="th" scope="row">
          {data.cropName}
        </StyledTableCell>
        <StyledTableCell align="center">
          {Number(data.area.toFixed(2))}
        </StyledTableCell>
        <StyledTableCell align="right">
          {Number(data.paymentIncome.toFixed(2))}
        </StyledTableCell>
        <StyledTableCell align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow dropdownDetails key={data.cropName + ' details row'}>
        <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={2}>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Numer teryt</StyledTableCell>
                      <StyledTableCell align="center">
                        Powierzchnia (ha)
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        Suma dochodów z dopłat (zł)
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <AssesmentDataDetailsRow
                      details={data.terytList}
                      key={data.cropName + ' details'}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Collapse>
        </TableCell>
      </StyledTableRow>
    </>
  );
}
